import { graphql } from '../../../gql';

export const GET_USER_POSTS_QUERY = graphql(`
  query getUserPosts($username: String!) {
    getUserPosts(username: $username) {
      id
      PK
      SK
      status
      categories
      textBlocks { ...TextBlockFields }
      textBlocksVersions {
        blocks { ...TextBlockFields }
        id
      }
      postAnalytics { ...PostAnalyticsCardFields }
      article
      score
      createdAt
      updatedAt
      viewerInteractions { ...ViewerInteractionFields }
      moderationStatus
      moderation { ...PostModerationMetaFields }
      communityReports { ...CommunityReportFields }
    }
  }
`);
